export default __webpack_public_path__ + "static/media/mouseseting.90fbc578.png";